import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './breadcrumb.module.css';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-closing-tag-location */

export const FullReturnsBreadcrumb = ({ step, disabledStep2, handleStepClick }) => (
  <div className={s.breadcrumb_image_container}>
    {step === 1 && (
      <svg width="200" height="40" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g className="cta-svg breadcrumb-fill" transform="translate(26 14)">
            <path
              d="M80.931 8V6H79v2h1.931zm3.862 0V6h-1.93v2h1.93zm3.862 0V6h-1.93v2h1.93zm3.862 0V6h-1.93v2h1.93zm3.862 0V6h-1.93v2h1.93zm3.862 0V6h-1.93v2h1.93zm3.862 0V6h-1.93v2h1.93zm3.863 0V6h-1.932v2h1.932zm3.862 0V6h-1.931v2h1.93zm3.862 0V6h-1.931v2h1.93zm3.862 0V6h-1.931v2h1.93zm3.862 0V6h-1.931v2h1.93zm3.862 0V6h-1.931v2h1.93zm3.862 0V6h-1.931v2h1.93zM135 8V6h-1.931v2H135zM12 8V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2z"
              fillRule="nonzero"
            />
            <ellipse cx="6.5" cy="6.5" rx="6.5" ry="6.5" />
            <path
              d="M141.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM74.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
              fillRule="nonzero"
            />
          </g>
        </g>
      </svg>
    )}
    {step === 2 && (
      <svg width="200" height="40" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g className="cta-svg breadcrumb-fill" transform="translate(26 14)" fill="#F65300">
            <path
              d="M79 8V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2zm4 0V6h-2v2h2z"
              fillRule="nonzero"
            />
            <ellipse cx="6.5" cy="6.5" rx="6.5" ry="6.5" />
            <ellipse cx="74.5" cy="6.5" rx="6.5" ry="6.5" />
            <path
              fillRule="nonzero"
              d="M78.432 7H80V5H11v2h1.568zM141.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
            />
          </g>
        </g>
      </svg>
    )}
    {step === 3 && (
      <svg width="200" height="40" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g className="cta-svg breadcrumb-fill" transform="translate(26 14)" fill="#F65300">
            <ellipse cx="6.5" cy="6.5" rx="6.5" ry="6.5" />
            <ellipse cx="74.5" cy="6.5" rx="6.5" ry="6.5" />
            <ellipse cx="141.5" cy="6.5" rx="6.5" ry="6.5" />
            <path fillRule="nonzero" d="M78.432 7H80V5H11v2h1.568z" />
            <path fillRule="nonzero" d="M145.432 7H147V5H78v2h1.568z" />
          </g>
        </g>
      </svg>
    )}
    <div className={s.breadcrumb_link_container}>
      <a
        className={cx({
          [s.breadcrumb_link]: true,
          [s.breadcrumb_link_active]: step > 1,
        })}
        onClick={(e) => handleStepClick(1, e)}
        aria-label={`Redirect to Step 1 ${step < 1 ? ' (Inactive)' : ''}`}
        href="#"
        aria-disabled={step <= 1}
        tabIndex={step <= 1 ? -1 : 0}
        role="button"
        data-test="breadcrumb-step-1"
      ></a>
      <a
        className={cx({
          [s.breadcrumb_link]: true,
          [s.breadcrumb_link_active]: step > 2,
          [s.breadcrumb_link_disabled]: disabledStep2,
        })}
        onClick={(e) => handleStepClick(2, e)}
        aria-label={`Redirect to Step 2 ${step < 2 ? ' (Inactive)' : ''}`}
        href="#"
        aria-disabled={step <= 2}
        tabIndex={step <= 2 ? -1 : 0}
        role="button"
        data-test="breadcrumb-step-2"
      ></a>
      <a
        href="#"
        className={s.breadcrumb_link}
        aria-label={`Redirect to Step 3 ${step < 3 ? ' (Inactive)' : ''}`}
        onClick={(e) => handleStepClick(false, e)}
        aria-disabled={step <= 3}
        tabIndex={step <= 3 ? -1 : 0}
        role="button"
        data-test="breadcrumb-step-3"
      ></a>
      <div className="clearfix" />
    </div>
  </div>
);

FullReturnsBreadcrumb.propTypes = {
  step: PropTypes.number.isRequired,
  disabledStep2: PropTypes.bool.isRequired,
  handleStepClick: PropTypes.func.isRequired,
};
